<template>
<div>
    
  <company-client-typeahead></company-client-typeahead >
 
  
  <div class="" style="height:100%">
  
    <h4 v-show="false" class="alert alert-warning text-center">
    <span class="pre" v-text="companyCallCenter.messageTextPre"></span>
    <strong class="short" v-text="companyCallCenter.messageTextShort"></strong>
    <span class="post" v-text="companyCallCenterMessageTextPost"></span>
    </h4>
    
    <div style="margin-top: 60px; border-bottom: 1px solid #CCC;">
      <h2>
        <i class="fa fa-home " aria-hidden="true"></i>
        Callcenter: {{companyCallCenter.name}} 
        <a style="padding-left: 10px; font-size: 16px" target="_blank" href="https://cc-pronto3.cmx-solutions.com/admin/main.php?mode=cfg">Administration</a>
        <div class="small pull-right">
          ACD:
          <span v-if="acdText == 'Off'" >nicht eingrichtet!</span>
          <span v-else>{{acdText}}</span>
          <button  v-if="acdText != 'Off' && !acdIntervalStatus" class="btn btn-sm btn-default" type="button" @click="$refs.ccCompanyAcd.startInterval()" title="Automatische ACD Statusabfrage starten">
            <i class="fa fa-play " aria-hidden="true"></i>
          </button>
          <button  v-if="acdText != 'Off' && acdIntervalStatus" class="btn btn-sm btn-default" type="button" @click="$refs.ccCompanyAcd.stopInterval()" title="Automatische ACD Statusabfrage stoppen">
            <i class="fa fa-pause " aria-hidden="true"></i>
          </button>
          <button  v-if="acdText != 'Off'" class="btn btn-sm btn-default" type="button" @click="$refs.ccCompanyAcd.refresh()" title="refresh status">
            <i class="fa fa-refresh " aria-hidden="true"></i>
          </button>
  
        </div>
      </h2>
    </div> 


    <div class="row" style="height: calc(100% - 170px)">

      <div class="col-xs-8" style="border-right: 1px solid #CCC; height:100%">
       <div class="cc-memo-list">
        <div class="panel-group" id="company-client-memo-accordion" role="tablist" aria-multiselectable="true">
          <cc-memo
            class="panel cc-panel-default cc-memo-item"
            v-for="(memo, index) in memos"
            :collapseIn="false"
            :data_parent="'company-client-memo-accordion'"
            :memo="memo"
            :key="memo.id" 
            @remove="onRemoveMemo"
            @update="onSetMemo">
          </cc-memo>
        </div>
      
        <div v-show="!memos.length" class="alert alert-warning" role="alert">Keine internen Vorgaben</div>
<!--
        <cc-memo 
          v-if="companyCallCenter.id > 0"
          class="cc-kombox-item" 
          :idCompany="companyCallCenter.id"
          :idUser="0"
          @insert="onAddMemo">
        </cc-memo>
-->      
       </div>
      </div>

      <div class="col-xs-4" style="height:100%;">
        <cc-company-acd @status="onAcdStatus" ref="ccCompanyAcd"></cc-company-acd>
      </div>
     
     </div>
          
  </div>            
                   
</div>      
</template>



<script>

import * as miscConf from './common/misc.conf'

import CompanyAcd from './CompanyAcd.vue'
import Kombox from './Kombox.vue'
import Memo from './Memo.vue'
import bus from './common/bus'
import CompanyClientTypeahead from './CompanyClientTypeahead.vue'


export default {
    
  components: {
    'company-client-typeahead': CompanyClientTypeahead,
    'cc-kombox': Kombox,
    'cc-memo': Memo,
    'cc-company-acd': CompanyAcd,
  },
  
  data () {
    return {
      companyCallCenter: {},         //bus.models.companyCallCenter, // bus refrenz
      memos:[],
      komboxes:[],
      shippingIds: bus.shipping.idsCompanyClient, // bus refrenz
      acdIntervalStatus: true
    }
  },
  
  created: function () {
    console.log('CompyanyCallCenter:created');
    this.loadCompyanyCallCenter();
    this.loadMemos();
    //this.loadKomboxes();

  },

  
  computed: {
    
    
    acdText: function() {
      // ToDo move to a config file -> i18n
      return miscConf.acdText(bus.login.companyCallCenter.acdTyp);
    },


    companyCallCenterMessageTextPost: function () {
      var ret = this.companyCallCenter.messageTextPost;
      if(typeof ret == "string"){
        ret = ret.replace(/<vname>/gi, bus.login.userCallCenter.firstName);
        ret = ret.replace(/<nname>/gi, bus.login.userCallCenter.lastName);
        ret = ret.replace(/<agent>/gi, bus.login.userCallCenter.firstName + ' ' + bus.login.userCallCenter.lastName);
      }
      return ret;
    },
    
    calledNumber: function() {
      return bus.call.calledNumber;
    },


  },
  
  methods: {
    
    onAcdStatus: function(status) {
      this.acdIntervalStatus = status
    },
    
    
    onRemoveMemo: function (memo) {
      const indexOf = this.memos.indexOf(memo);
      if(indexOf != -1){
        this.memos.splice(indexOf, 1);
      }
    },
    
    onSetMemo: function (memo) {
      const indexOf = _.findIndex(this.memos, ['id', memo.id]);
      if(indexOf != -1){
        this.$set(this.memos, indexOf, memo);
      }
    },
    
    onAddMemo: function (memo) {
        this.memos.push(memo);
    },
    
    onRemoveKombox: function (kombox) {
      const indexOf = this.komboxes.indexOf(kombox);
      if(indexOf != -1){
        this.komboxes.splice(indexOf, 1);
      }
    },
    
    onSetKombox: function (kombox) {
      // Note: kombox is a reference or a clone
      const indexOf = _.findIndex(this.komboxes, ['id', kombox.id]);
      if(indexOf != -1){
        this.$set(this.komboxes, indexOf, kombox);
      }
    },

    onAddKombox: function (kombox) {
        this.komboxes.push(kombox);
    },

    
    onKomboxAddShipping: function (kombox) {
      if(this.shippingIds.indexOf(kombox.id) == -1){
        this.shippingIds.push(kombox.id);
      }
    },

    onKomboxRemoveShipping: function (kombox) {
      this.shippingIds.splice(this.shippingIds.indexOf(kombox.id), 1);
    },
    

    
    reset: function () {
      // bus.resetCompyanyCallCenter(); // bus refrenz
      this.companyCallCenter = {};
      
      this.memos = [];
      this.komboxes = [];
      this.shippingIds.splice(0 , this.shippingIds.length); // bus refrenz on this.shippingIds
      
    },
    
    loadCompyanyCallCenter: function (idCompyanyCallCenter) {
      this.$http.get(bus.config.path + '/company/client/' + bus.call.idCompanyCallCenter).then((response) => {
        //this.companyCallCenter = _.assignIn(this.companyCallCenter, response.data); // bus refrenz
        this.companyCallCenter = response.data;
      
      }, (response) => {
      // error callback
      });
    },

    loadMemos: function (idCompyanyCallCenter) {
      this.$http.get(bus.config.path + '/company/memos/' + bus.call.idCompanyCallCenter, {params: {typ: '2'}}).then((response) => {
        this.memos = response.data;
        //console.log(response.data);

      }, (response) => {
      // error callback
      });
    },

    loadKomboxes: function (idCompyanyCallCenter) {
      this.$http.get(bus.config.path + '/company/komboxes/' + bus.call.idCompanyCallCenter).then((response) => {
        this.komboxes = response.data;
        //console.log(response.data);

      }, (response) => {
      // error callback
      });
    },
    
  }
  
}
</script>



<style scoped>
  
  .panel-group, .panel{
    margin-bottom: 0px;
  }  
  
h2 .fa {
    padding-right: 12px;
    color: #337ab7;
}
.btn-default .fa {
    padding-right: 0px;
    font-size: 1.0em;
}  

.cc-kombox-item{
    border-bottom: 1px solid lightgrey;
    padding-top: 5px;
    padding-bottom: 5px;
  
}  

.cc-kombox-item:hover,
.cc-memo-item:hover{
  background-color: #fcf8e3;
}

.cc-kombox-list, 
.cc-memo-list{
    height: 100%;
    overflow: auto;
}
  
  
</style>



// WEBPACK FOOTER //
// CompanyCallCenter.vue?157cc54a